import { useContext } from "react";

import { SizeContext } from "../providers/Size";

export const MOBILE_WIDTH_BREAKPOINT = 768;

export function useMode() {
  const { size: windowSize } = useContext(SizeContext);

  const mode = windowSize
    ? windowSize.width >= MOBILE_WIDTH_BREAKPOINT
      ? "desktop"
      : "mobile"
    : null;

  return mode;
}
